import { TemplateConfig } from '../types';

export const examPreparationConfig: TemplateConfig = {
  id: 'exam-preparation',
  name: '备考牌阵',
  description: '分析备考期间的各方面情况',
  cardCount: 6,
  
  fieldDefaults: {
    title: '备考牌阵',
    customerQuestion: '**备考时的情况**',
    cardInfos: [
      '备考中的个人状态，需要增强或改进的地方',
      '备考中的必修课、精神课题',
      '备考中的感情、人际方面的发展',
      '备考中的行动力方面的情况',
      '备考中的学业发展趋势或物质情况',
      '备考中的思维、技能各方面的情况'
    ],
    cardPlaceholders: [
      '请输入第 3 行第 1 张牌',
      '请输入第 1 行第 1 张牌',
      '请输入第 2 行第 2 张牌',
      '请输入第 4 行第 2 张牌',
      '请输入第 4 行第 1 张牌',
      '请输入第 2 行第 1 张牌'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#1890ff',
    backgroundColor: '#e6f7ff',
    icon: '📚'
  }
};